import {
  ActionsClinicInfo,
  BooleanCons,
  NumberCons,
  PaymentTypeInfo,
  StringConst,
  TabsNames,
} from '../../constants/const';
import { PowerBIReportTypes } from '../http/catalogs';
import { CallPlace } from '../http/myActivity.model';
import { CartContentType, ShippingDiscountType } from '../http/shoppingList';
import { InformationClinics } from './information.clinics.model';

export class HeaderPage {
  title?: string;
  description?: string;
}

export class GeneralTotalDescription {
  totalProducts: number;
  totalPices: number;
  subTotal: number;
  generalTax: number;
  costShipping: number;
  totalUtilities?: number;
  totaldiscount: number;
  constructor() {
    this.totalProducts = NumberCons.zero;
    this.totalPices = NumberCons.zero;
    this.subTotal = NumberCons.zero;
    this.generalTax = NumberCons.zero;
    this.costShipping = NumberCons.zero;
    this.totalUtilities = NumberCons.zero;
    this.totaldiscount = NumberCons.zero;
  }
}

export class TotalDescriptionShopping {
  productTotal: number;
  piecesTotal: number;
  subtotal: number;
  sendCost: number;
  rebate: number;
  tax: number;
  total: number;
  isFromShoppingList?: boolean;
  isFromDetailOrders?: boolean;
  fromCalled?: CallPlace;
  isHideTotalsHeader?: boolean;
  costShipping: number;
  promotionalCodeAmount: number;
  totalUtilities: number;
  totaldiscount: number;
  isAuthorizeOrderButton: boolean;
  needsRecipe: number;
  isRecipeAuthorized: number;
  cartContentType: CartContentType;
  hasDiscountSpecial: boolean;
  discountSpecial: number;
  totalWithSpecialDiscount: number;
  percentDiscountSpecial: number;
  hasFavorBalance: boolean;
  favorBalance: number;
  shippingCostDiscountPercent: number;
  validShippingTypes: string[];
  shippingDiscountType: ShippingDiscountType;
  shippingDiscountValue: number;
  constructor() {
    this.subtotal = NumberCons.zero;
    this.sendCost = NumberCons.zero;
    this.rebate = NumberCons.zero;
    this.tax = NumberCons.zero;
    this.total = NumberCons.zero;
    this.piecesTotal = NumberCons.zero;
    this.productTotal = NumberCons.zero;
    this.isFromShoppingList = false;
    this.isFromDetailOrders = false;
    this.fromCalled = CallPlace.default;
    this.isHideTotalsHeader = false;
    this.costShipping = NumberCons.zero;
    this.totalUtilities = NumberCons.zero;
    this.totaldiscount = NumberCons.zero;
    this.isAuthorizeOrderButton = BooleanCons.false;
    this.needsRecipe = NumberCons.zero;
    this.isRecipeAuthorized = NumberCons.zero;
    this.cartContentType = CartContentType.default;
    this.hasDiscountSpecial = BooleanCons.false;
    this.discountSpecial = NumberCons.zero;
    this.totalWithSpecialDiscount = NumberCons.zero;
    this.percentDiscountSpecial = NumberCons.zero;
    this.hasFavorBalance = BooleanCons.false;
    this.favorBalance = NumberCons.zero;
    this.promotionalCodeAmount = NumberCons.zero;
    this.shippingCostDiscountPercent = NumberCons.zero;
    this.validShippingTypes = [];
    this.shippingDiscountType = ShippingDiscountType.default;
    this.shippingDiscountValue = NumberCons.zero;
  }
}

export class SignatureData {
  signature: string;
  fromCalled: CallPlace;

  constructor() {
    this.signature = StringConst.empty;
    this.fromCalled = CallPlace.default;
  }
}

export class FileSelectedResult {
  type: string;
  base64?: string;
  isUpdate?: boolean;
  withPrefix?: string;
  file?: File;
  typeImageToSave?: string;
  constructor() {
    this.type = StringConst.empty;
    this.base64 = StringConst.empty;
    this.withPrefix = StringConst.empty;
  }
}

export class DefaultAddress {
  doctorId: string;
  addressName: string;
  type: AddressType;
  constructor() {
    this.doctorId = StringConst.empty;
    this.addressName = StringConst.empty;
    this.type = AddressType.none;
  }
}

export enum AddressType {
  delivered = 'S',
  tax = 'B',
  none = '',
}

export class OpenDetailOrderData {
  orderId: string;
  callPlace: CallPlace;
  stringOrderId?: string;
  isAuthorizeOrder: boolean;
  statusOrder?: string;
  isPaymentProcessed: boolean;
  showFavoriteButton: boolean;
  line: string;
  constructor() {
    this.callPlace = CallPlace.default;
    this.orderId = StringConst.empty;
    this.stringOrderId = StringConst.empty;
    this.isAuthorizeOrder = BooleanCons.false;
    this.statusOrder = StringConst.empty;
    this.isPaymentProcessed = BooleanCons.false;
    this.showFavoriteButton = BooleanCons.true;
    this.line = StringConst.empty;
  }
}
export class CloseDetailOrderData {
  callPlace: CallPlace;
  stringOrderId: string;
  createName: string;
  isPaymentAuthorized: boolean;
  isAuthorized: boolean;
  method: PaymentTypeInfo;
  constructor() {
    this.createName = StringConst.empty;
    this.callPlace = CallPlace.default;
    this.stringOrderId = StringConst.empty;
    this.isPaymentAuthorized = BooleanCons.false;
    this.isAuthorized = BooleanCons.false;
    this.method = PaymentTypeInfo.default;
  }
}

export class UpdateProfilePhoto {
  doctorId: string;
  profilePicture: string;
  needsUpdate: boolean;
  pictureFormat: string;

  constructor() {
    this.doctorId = StringConst.empty;
    this.profilePicture = StringConst.empty;
    this.needsUpdate = true;
    this.pictureFormat = 'jpeg';
  }
}

export const enum TabsProfile {
  profile,
  accountSettings,
  recipeSettings,
  responsibleDoctors,
  paymentMethods,
  deliveryAddresses,
  taxData,
  default,
}

export const enum TabsProfileDoctorView {
  profile,
  recipeSettings,
  responsibleDoctor,
  paymentMethods,
  deliveryAddresses,
  taxData,
  default,
}

export const enum TabsOrders {
  active,
  pending,
  delivered,
  default,
}

export const enum TabsMissingProducts {
  rawMaterial,
  container,
  productEnd,
}

export const enum TabsDoctorProfile {
  profile,
  configAccount,
  configRecipe,
  responsibleDoctor,
  payMethods,
  delivery,
  taxData,
}

export const enum TabsDoctorProfileAsesorView {
  profile,
  configRecipe,
  payMethods,
  delivery,
  taxData,
}

export const enum TabsUtilitiesCalculator {
  utilities,
  analysisBusiness,
  potencialBusiness,
  utilitiesCalculator,
}

export const TabsMissingProductsCompare = {
  rawMaterial: 0,
  container: 1,
  productEnd: 2,
};

export const TabOrdersCompare = {
  active: 0,
  pending: 1,
  delivered: 2,
};

export const TabDoctorProfileCompare = {
  profile: 0,
  configAccount: 1,
  configRecipe: 2,
  responsibleDoctor: 3,
  payMethods: 4,
  delivery: 5,
  taxData: 6,
};

export const TabDoctorProfileAdvisorViewCompare = {
  profile: 0,
  configRecipe: 1,
  payMethods: 2,
  delivery: 3,
  taxData: 4,
};

export const TabUtilitiesCalculatorCompare = {
  utilities: 0,
  analysisBusiness: 1,
  potencialBusiness: 2,
  utilitiesCalculator: 3,
};

export class SaveProfileInfo {
  doctorId: string;
  phoneNumber: string;
  whatsapp: string;
  additionalPhone: string;
  facebookPage: string;
  twitterPage: string;
  instagramPage: string;
  birthDate?: Date | null;
  doctorName: string;
  authorizedPersonnel?: AuthorizedPersonnel | null;
  additionalInformation: AdditionalInformation | null;
  webSitePage: string;

  constructor() {
    this.doctorId = StringConst.empty;
    this.phoneNumber = StringConst.empty;
    this.whatsapp = StringConst.empty;
    this.additionalPhone = StringConst.empty;
    this.facebookPage = StringConst.empty;
    this.twitterPage = StringConst.empty;
    this.instagramPage = StringConst.empty;
    this.birthDate = null;
    this.doctorName = StringConst.empty;
    this.authorizedPersonnel = null;
    this.additionalInformation = null;
    this.webSitePage = StringConst.empty;
  }
}
export enum TransformDateType {
  ddmmyy,
  yymmdd,
}
export class AdditionalInformation {
  associationToWhichItBelongs: string;
  publicInstitutionWhichIProvideMyServices: string;

  constructor() {
    this.associationToWhichItBelongs = StringConst.empty;
    this.publicInstitutionWhichIProvideMyServices = StringConst.empty;
  }
}

export class AuthorizedPersonnel {
  assistanceName: string;
  assistanceWhatsapp: string;
  assistanceBirthDate: Date | null;
  assistanceJob: string;

  constructor() {
    this.assistanceName = StringConst.empty;
    this.assistanceWhatsapp = StringConst.empty;
    this.assistanceBirthDate = null;
    this.assistanceJob = StringConst.empty;
  }
}
export class LicenseToCheck {
  maxResult: number;
  nombre: string;
  paterno: string;
  materno: string;
  idCedula: string;

  constructor() {
    this.maxResult = 10;
    this.nombre = StringConst.empty;
    this.paterno = StringConst.empty;
    this.materno = StringConst.empty;
    this.idCedula = StringConst.empty;
  }
}

export enum RecipeSettingsActions {
  default = 'USE',
  insert = 'I',
  update = 'U',
  delete = 'D',
  none = '',
}

export interface OptionsOpenPayError {
  mount?: number;
  typeMethod?: string;
}

export class UpdateClinicInfo {
  cardCode: string;
  clinicName: string;
  clinicPhone: string;
  zipCode: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  streetNumber: string;
  facebookPage: string;
  twitterPage: string;
  instagramPage: string;
  webSitePage: string;
  medics: string;
  patientsPerDay: string;
  operationDays: string;
  action: ActionsClinicInfo;
  extraClinicInfo: ExtraClinicInfo;

  constructor() {
    this.cardCode = StringConst.empty;
    this.clinicName = StringConst.empty;
    this.clinicPhone = StringConst.empty;
    this.zipCode = StringConst.empty;
    this.state = StringConst.empty;
    this.city = StringConst.empty;
    this.neighborhood = StringConst.empty;
    this.street = StringConst.empty;
    this.streetNumber = StringConst.empty;
    this.facebookPage = StringConst.empty;
    this.twitterPage = StringConst.empty;
    this.instagramPage = StringConst.empty;
    this.webSitePage = StringConst.empty;
    this.medics = StringConst.empty;
    this.patientsPerDay = StringConst.empty;
    this.operationDays = StringConst.empty;
    this.action = ActionsClinicInfo.none;
    this.extraClinicInfo = new ExtraClinicInfo();
  }
}

export class ExtraClinicInfo {
  firstAilment: string;
  secondAilment: string;
  thirdAilment: string;
  percentFirstAilment: string;
  percentSecondAilment: string;
  percentThirdAilment: string;

  constructor() {
    this.firstAilment = StringConst.empty;
    this.secondAilment = StringConst.empty;
    this.thirdAilment = StringConst.empty;
    this.percentFirstAilment = StringConst.empty;
    this.percentSecondAilment = StringConst.empty;
    this.percentThirdAilment = StringConst.empty;
  }
}

export class ClinicInfoToModal {
  clinicInfo: InformationClinics;
  action: ActionsClinicInfo;
  clinicsInfoRef: InformationClinics[];

  constructor() {
    this.clinicInfo = new InformationClinics();
    this.action = ActionsClinicInfo.none;
    this.clinicsInfoRef = [];
  }
}

export class DateRangePicker {
  start: Date;
  end: Date;
  constructor() {
    this.start = new Date();
    this.end = new Date();
  }
}

export class SelectedDateRange {
  range: DateRangePicker;
  isRange: boolean;
  constructor() {
    this.range = new DateRangePicker();
    this.isRange = BooleanCons.false;
  }
}
export class ConfigComponent {
  isWithHeader = false;
  isHideFavorite = false;
}
export class ConfigUtilities extends ConfigComponent {
  headerPage = new HeaderPage();
  titleTotal = '';
  isOpenPieces = false;
  titlePieces = '';
  typeUtility = '';
}
export class ConfigInputAutoComplete {
  typeInput = '';
  labelInput = '';
  placeHolderInput = '';
  isDermazone = false;
  group = '';
  activeFilters: string[] = [];
  activeSelect: number[] = [];
  listOnlySpecialtiesSelect: number[] = [];
}

export class ProfileTabConfig {
  indexTab: number;
  tab: TabsProfile;
  constructor() {
    this.indexTab = NumberCons.zero;
    this.tab = TabsProfile.profile;
  }
}

export class UpdatePhotoValidators {
  place: CallPlace[];
  rol: string;
  flag: boolean;
  changeForAdvisor: boolean;
  changeForDoctor: boolean;
  changeForReporter: boolean;
  constructor() {
    this.place = [];
    this.rol = StringConst.empty;
    this.flag = BooleanCons.false;
    this.changeForAdvisor = BooleanCons.false;
    this.changeForDoctor = BooleanCons.false;
    this.changeForReporter = BooleanCons.false;
  }
}

export class ReturnToTab {
  tab: TabsProfile;
  isFromReturn: boolean;
  bottomsheet: TabsNames;

  constructor() {
    this.tab = TabsProfile.profile,
      this.isFromReturn = BooleanCons.false;
    this.bottomsheet = TabsNames.profile;
  }
}

export interface SectionsToShow {
  [key: string]: boolean;
}

export class Pagination {
  offset: number;
  limit: number;
  index: number;

  constructor() {
    this.offset = NumberCons.zero;
    this.limit = NumberCons.ten;
    this.index = NumberCons.zero;
  }
}

export class ContinueBackMessage {
  title: string;
  message: string;
  continueButton: string;
  backButton: string;

  constructor() {
    this.title = StringConst.empty;
    this.message = StringConst.empty;
    this.continueButton = StringConst.empty;
    this.backButton = StringConst.empty;
  }
}

export interface PowerBiReport {
  reportName: string;
  token: string;
  reportId: string;
  reportUrl: string;
}

export const ReportsData: { [key: number]: PowerBiReport } = {
  1: {
    reportName: PowerBIReportTypes.businessAnalysis,
    token: StringConst.empty,
    reportId: StringConst.empty,
    reportUrl: StringConst.empty,
  },
  2: {
    reportName: PowerBIReportTypes.businessPotential,
    token: StringConst.empty,
    reportId: StringConst.empty,
    reportUrl: StringConst.empty,
  },
};

export class FreeShippingWarningEmitter {
  shipingCostDiscountEmitter: boolean;
  shipingCostDiscountAmountEmitter: number;
  freeShippingWarningEmitter: number;
  showShippingMesage: boolean;
  constructor() {
    this.shipingCostDiscountEmitter = BooleanCons.false;
    this.shipingCostDiscountAmountEmitter = NumberCons.zero;
    this.freeShippingWarningEmitter = NumberCons.zero;
    this.showShippingMesage = BooleanCons.false;
  }

}

export class ChangeInvoiceMssgDialogConfig {
  catalogs: string;
  requireInvoice: boolean;
  constructor() {
    this.catalogs = StringConst.empty;
    this.requireInvoice = BooleanCons.false;
  }
}
